const tiers = [
  {
    name: "Free",
    price: "₹0",
    benefits: [
      "Browse all products",
      "Standard customer support",
      "Access to general discounts",
    ],
    bgColor: "bg-gradient-to-r from-gray-200 to-gray-300",
    textColor: "text-gray-500",
    bgColorForShadow: "#9CA3AF",
    textColorBeforeHover: "#000000",
  },
  {
    name: "Basic",
    price: "₹499.99",
    benefits: [
      "Exclusive member-only discounts",
      "Early access to sales",
      "Priority customer support",
    ],
    bgColor: "bg-gradient-to-r from-blue-200 to-blue-300",
    textColor: "text-blue-900",
    bgColorForShadow: "#3B82F6",
    textColorBeforeHover: "#1E3A8A",
  },
  {
    name: "Pro",
    price: "₹1499.99",
    benefits: [
      "All Basic benefits",
      "Faster shipping on orders",
      "Special pricing on select gadgets",
    ],
    bgColor: "bg-gradient-to-r from-green-200 to-green-300",
    textColor: "text-green-900",
    bgColorForShadow: "#22C55E",
    textColorBeforeHover: "#134E4A",
  },
  {
    name: "Ultimate",
    price: "₹3499.99",
    benefits: [
      "All Pro benefits",
      "Free shipping on all orders",
      "Exclusive access to new tech launches",
    ],
    bgColor: "bg-gradient-to-r from-purple-200 to-purple-300",
    textColor: "text-purple-900",
    bgColorForShadow: "#A855F7",
    textColorBeforeHover: "#5B21B6",
  },
];

export default tiers;
